import React from 'react';
import PropTypes from 'prop-types';
import ProgressBar from '@ey/motif-react-wrapper/ProgressBar';
import Icon from '@ey/motif-react-wrapper/Icon';
import '../_timeline.scss';
import {
	notificationIcPriorityHigh12px,
	navigationIcCheck24px
} from '@ey/motif-react-wrapper/assets/icons/index';

const Milestone = React.memo(
	({ progress, past }) => {
		const progressValue = progress === null && past ? 100 : progress;

		return (
			<React.Fragment>
				<ProgressBar value={progressValue} circle />
				{progressValue === 100 && (
					<div
						className="motif-timeline-checkmark"
						aria-label="complete checkmark"
					>
						<Icon src={navigationIcCheck24px} />
					</div>
				)}
				{progressValue < 100 && (
					<React.Fragment>
						{!past && (
							<div
								className="motif-timeline-no-checkmark"
								aria-label="completed no checkmark"
							/>
						)}
						{past && (
							<div
								className="motif-timeline-x"
								aria-label="not completed crossmark"
							>
								<Icon src={notificationIcPriorityHigh12px} />
							</div>
						)}
					</React.Fragment>
				)}
			</React.Fragment>
		);
	},
	(prevProps, nextProps) =>
		prevProps.progress === nextProps.progress &&
		prevProps.past === nextProps.past
);

Milestone.defaultProps = {
	progress: null,
	past: false
};

Milestone.propTypes = {
	progress: PropTypes.number,
	past: PropTypes.bool
};

export default Milestone;
